import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string
    }
  }
}

const theme = createTheme({
  palette: {
    mode: 'light', // dark
    primary: {
      main: '#55B3D7',
    },
    secondary: {
      main: '#55B3D7',
    },
  },
  typography: {
    fontFamily: 'Roboto',
    fontSize: 16,
  },
})

export default theme
